import HomeCrazy from "./HomeCrazy"

export default HomeCrazy